/**
 * External dependencies
 */
import { mdiFolderOpen } from '@mdi/js';

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import Card from '../../components/card';

const CustomId = () => {
	return (
		<Card
			icon={mdiFolderOpen}
			id="custom-id"
			title={__('Keep media library structure', 'cf-images')}
		>
			<div className="content">
				<p>
					{__(
						'Preserve the WordPress media library paths, when uploading images to Cloudflare Images, instead of the path automatically generated by Cloudflare Images’ Universal Unique Identifier (UUID).',
						'cf-images'
					)}
				</p>
				<p>
					{__(
						'This does not convert already uploaded images. To change all the images to the new format (or back), you will need to perform bulk remove & upload.',
						'cf-images'
					)}
				</p>
			</div>
		</Card>
	);
};

export default CustomId;
